"use client";
import * as React from "react";
const SvgWarningSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0 13.9h16L8 .1zm8.73-2.17H7.27v-1.46h1.46zm0-2.91H7.27V5.9h1.46z" }));
export {
  SvgWarningSharp as default
};
